import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

const ForwardCoachingCard = () => {
  const isPlace = useIsPlace();
  const openLearnMore = () => {
    window.open(
      isPlace
        ? "https://forwardcoaching.com/real-estate-coaching/?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=PLACE-FC-button"
        : "https://forwardcoaching.com/real-estate-coaching/?utm_campaign=AO-Product-AddOns-BP&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=BP-FC-button",
      "_blank",
    );
  };

  return (
    <ZoomCard
      actions={
        <>
          <Button
            size="medium"
            schema="secondary"
            className="tw-flex tw-items-center tw-gap-[4px]"
            onClick={() => {
              window.open(
                isPlace
                  ? "https://info.forwardcoaching.com/placeopcoaching?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=get-coaching&utm_content=PLACE-FC-button"
                  : "https://forwardcoaching.com/consultation/?utm_campaign=AO-Product-AddOns-BP&utm_source=in-app&utm_medium=organic&utm_term=get-coaching&utm_content=BP-FC-button",
                "_blank",
              );
            }}
          >
            Get Coaching <ArrowUpRightFromSquareSolidV6 />
          </Button>
          <TextButton
            className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
            size="medium"
            onClick={openLearnMore}
          >
            Learn More <ArrowUpRightFromSquareSolidV6 />
          </TextButton>
        </>
      }
      onClick={openLearnMore}
      title="Forward Coaching"
      description="Stretch the limits of personal performance, business growth, and financial abundance with forward coaching by Debbie De Grote and her team of coaches."
      imgSrc="/images/bg-card-forward-coaching.png"
      imgClassName="tw-ml-[-12px] tw-mr-[24px]"
    />
  );
};

export default ForwardCoachingCard;
